import { PersonService } from '../../services/person.service';
import { MasterdataAService, SettingsService, TemplatesService } from "../../services/index";
import { TimezonesService, ITimezone } from "../../services/timezone.service";
import { StaffService } from "../../services/staff.service";
import { SalaryScaleGroupService, SalaryScaleService } from "../../services/salaryScaleGroup.service";
import { HourCodeService } from "../../services/hourCode.service";
export const settingsState: aboTheme.IState = {

  parent: 'app',
  name: "settings",
  url: "/settings",
  component: 'settingsComponent',
  redirectTo: 'settings.company',
  data: {
    permissions: {
        only: ['BACKOFFICE'],
        redirectTo: 'schedule'
    }
  }

};

export const settingsCompanyState: aboTheme.IState = {

  name: "settings.company",
  url: "/company",
  resolve: {
     company: (SettingsService: SettingsService) => { 'ngInject'; return SettingsService.customGet('CompanySettings'); }
  },
  views : {
      "main" : "settingsCompanyComponent"
  }

};

export const settingsEmployeeState: aboTheme.IState = {

  name: "settings.employees",
  url: "/employee",
  redirectTo: 'settings.employees.list'

};

export const settingsEmployeeListState: aboTheme.IState = {

  name: "settings.employees.list",
  url: "/list",
  resolve : {
    "employees" : (PersonService: PersonService) => { "ngInject"; return PersonService.all(); }
  },
  views : {
      "main@settings" : "employeeListComponent"
  }

};

export const settingsEmployeeItemState: aboTheme.IState = {

  name: "settings.employees.item",
  url: "/:id",
  resolve : {
    "employee" : (PersonService: PersonService, $stateParams: ng.ui.IStateParamsService) => { 
      "ngInject"; 
      return PersonService.get($stateParams['id']); }
  },
  views : {
      "main@settings" : "employeeItemComponent"
  }

};

export const settingsSalaryScaleState: aboTheme.IState = {

  name: "settings.salaryscales",
  url: "/salaryscales",
  views : {
    "main@settings" : "salaryScaleListComponent"
  }
};

export const settingsSalaryScaleEditState: aboTheme.IState = {

  name: "settings.salaryscales.edit",
  url: "/:id",
  modal: true,
  resolve: {
    salaryScaleGroup: (SalaryScaleGroupService: SalaryScaleGroupService, $stateParams: ng.ui.IStateParamsService) => {
      "ngInject";
      if ($stateParams['id'] && $stateParams['id'] !== '') {
        return SalaryScaleGroupService.get($stateParams['id']);
      }
    }
  },
  component: 'salaryScalesDialogComponent'

};


export const templatesState: aboTheme.IState = {

  name: "settings.templates",
  url: "/templates",
  resolve: {
     templatesNames: (TemplatesService: TemplatesService) => { 'ngInject'; return TemplatesService.all(); }
  },
  views: {
    "main": "templatesEditorComponent"
  }

};

export const timezonesState: aboTheme.IState = {

  name: "settings.timezones",
  url: "/timezones",
  redirectTo: 'settings.timezones.list',
  views: {
    "main": "timezonesComponent"
  }

};

export const timezonesListState: aboTheme.IState = {

    name: "settings.timezones.list",
    url: "/list?:selectedCaoId",
    params: {
        selectedCaoId: { dynamic: true }
    },
    resolve: { 
        timezones: (TimezonesService: TimezonesService) => { 'ngInject'; return TimezonesService.all(); }
    },
    views: {
        "main" : 'timezonesListComponent'
    }
};

export const timezonesItemState: aboTheme.IState = {

    name: "settings.timezones.list.item",
    url: "/:id?:caoId",
    resolve: {
        timezone: (TimezonesService: TimezonesService, $stateParams:ng.ui.IStateParamsService) => { 
            'ngInject'; 
            if ($stateParams['id'] != '') {
                return TimezonesService.get($stateParams['id']);
            } 
        },
        hourCodes: (HourCodeService: HourCodeService, $stateParams: ng.ui.IStateParamsService, timezone: ITimezone) => {
            'ngInject';
            // Haal hourCodes op voor de CAO van de timezone (zonder ORT filter)
            const salaryScaleGroupId = (timezone && timezone.salaryScaleGroupId) || $stateParams['caoId'];
            if (salaryScaleGroupId) {
                return HourCodeService.getBySalaryScaleGroupIdForTimezones(salaryScaleGroupId);
            }
            // Als er geen CAO is, retourneer lege array
            return [];
        }
    },
    modal: ['timezone', 'hourCodes'],
    component: 'timezonesItemBasicComponent'
};

// export const timezonesItemBasicState: aboTheme.IState = {

//   name: "settings.timezones.list.basic",
//   url: "/:id",
//   modal: ['timezone', 'hourCodes'],
//   resolve: {
//   },
//   component: 'timezonesItemBasicComponent'

// };

export const staffState: aboTheme.IState = {

  name: "settings.staff",
  url: "/staff",
  redirectTo: 'settings.staff.list',
  views: {
    "main": "staffComponent"
  },
  data: {
    permissions: {
        only: ['SUPERUSER'],
        redirectTo: 'schedule'
    }
  }

};

export const staffListState: aboTheme.IState = {

  name: "settings.staff.list",
  url: "/list",
  resolve: { 
    staff: (StaffService: StaffService) => { 'ngInject'; return StaffService.all(); }
  },  
  views: {
    "main": "staffListComponent"
  }

};

export const staffItemState: aboTheme.IState = {

  name: "settings.staff.list.item",
  url: "/:id",
  // modal: [],
  resolve: {
      staff: (StaffService: StaffService, $stateParams:ng.ui.IStateParamsService) => { 'ngInject'; if ($stateParams['id'] != '') {
        // console.log($stateParams['id']);
        return StaffService.get($stateParams['id']);
      } },
  },
  modal: [],
  component: 'staffItemComponent'
};

export const masterdataState: aboTheme.IState = {

  name: "settings.masterdata",
  url: "/masterdata",
  redirectTo: 'settings.masterdata.list',
  views: {
    "main": "masterdataComponent"
  },
  data: {
    permissions: {
        only: ['BACKOFFICE'],
        redirectTo: 'schedule'
    }
  }

};

export const masterdataListState: aboTheme.IState = {

  name: "settings.masterdata.list",
  url: "/list?:tab",
  params: {
    tab: { dynamic: true },
  },
   resolve: {
        item: (MasterdataAService: MasterdataAService) => {
            'ngInject';
        }
    },
  views: {
    "main": 'masterdataListComponent'
  }

};

export const masterdataListEditState: aboTheme.IState = { 

    name: "settings.masterdata.list.edit",
    url: "/edit/:id?:type",
    params: {
        id: null,
        type: null
    },
    modal: true,
    resolve: {
        item: (MasterdataAService: MasterdataAService, $stateParams: ng.ui.IStateParamsService) => {
            'ngInject';
            if ($stateParams['id'] !== '') {
                return MasterdataAService.get($stateParams['id']);
            }
        }
    },
    component: 'masterdataEditComponent'

};

export const nmbrsTestState: aboTheme.IState = {

    name: "settings.nmbrsTest",
    url: "/nmbrs-test",
    views: {
        "main": "nmbrsTestComponent"
    },
    data: {
        permissions: {
            only: ['BACKOFFICE'],
            redirectTo: 'schedule'
        }
    }

};

export const hourCodesState: aboTheme.IState = {

  name: "settings.hourcodes",
  url: "/hourcodes",
  redirectTo: 'settings.hourcodes.list',
  views: {
    "main": "hourCodesComponent"
  }

};

export const hourCodesListState: aboTheme.IState = {

    name: "settings.hourcodes.list",
    url: "/list?:selectedCaoId",
    params: {
        selectedCaoId: { dynamic: true }
    },
    views: {
        "main" : 'hourCodesListComponent'
    }
};

export const hourCodesItemState: aboTheme.IState = {

    name: "settings.hourcodes.list.item",
    url: "/:id?:caoId",
    resolve: {
        hourCode: (HourCodeService: HourCodeService, $stateParams:ng.ui.IStateParamsService) => { 
            'ngInject'; 
            if ($stateParams['id'] != '') {
                return HourCodeService.get($stateParams['id']);
            } 
        }
    },
    modal: ['hourCode'],
    component: 'hourCodesItemBasicComponent'
};


// WEBPACK FOOTER //
// ./src/app/modules/settings/settings.states.ts